import { ascend, curry, prop, sort } from 'ramda'
import { useOnUnload } from '@btime/react-hooks'
import { generateContext } from '@btime/react-contexts'
import { State, moveTo, moveToIndexWith, setValue } from '@btime/state-monad'
import React, { useCallback, useContext, useMemo, useReducer } from 'react'

import { Reducer } from '../../../../utils/reducer/chain'
import { handleState } from '../../../../utils/reducer/basicStateHandler'
import { useLevelsState } from '../_load/LevelsLoader'

export const useAscSortedLevels = () => {
  const { levels } = useLevelsState()
  return useMemo(() => sort(ascend(prop('id')), levels), [levels])
}

const { StateContext, ActionsContext, Provider } = generateContext()
export const useLevelsSettingsForm = () => useContext(StateContext)
export const useLevelsSettingsFormActions = () => useContext(ActionsContext)

const SET_LEVEL_VALUE = 'SET_LEVEL_VALUE'

const reducer = (state, action) =>
  Reducer(state, action)
    .map(
      handleState(SET_LEVEL_VALUE, (state, action) => {
        const { id, field, value } = action.payload

        return State.of({ ...state, touched: true })
          .map(moveTo('levels'))
          .map(moveToIndexWith(item => item.id === id))
          .map(moveTo(field))
          .map(setValue(value))
          .fold()
      })
    )

    .foldState()

const Form = ({ children }) => {
  const levels = useAscSortedLevels()
  const [state, dispatch] = useReducer(reducer, { levels })
  useOnUnload({ condition: !!state.touched })

  const handleChange = useCallback(
    curry((id, field, value) => dispatch({ type: SET_LEVEL_VALUE, payload: { id, field, value } })),
    [dispatch]
  )

  return (
    <Provider
      state={state}
      actions={{
        handleChange
      }}
    >
      {children}
    </Provider>
  )
}

export default Form
